import type * as React from 'react';
import api from '../../../api';
import { DASHBOARD } from '../../../routes';
import Button from '../../components/Button';
import { useAppContext } from '../../hooks/useAppContext';
import { prependAppPath } from '../../services/Url';

const ImpersonationBanner: React.FC = () => {
    const { user } = useAppContext();
    const { impersonator } = user;

    if (!impersonator || user.loginname.endsWith('.fake')) {
        return null;
    }

    const endImpersonation = () => {
        api.users.impersonate(impersonator.id).then(() => window.location.assign(prependAppPath(DASHBOARD)));
    };

    return (
        <div className="boxWarning">
            You are impersonating {user.name}. Any action you perform will be real, and attributed to their account.{' '}
            <Button kind="LINK" onClick={endImpersonation}>
                End impersonation.
            </Button>
        </div>
    );
};

export default ImpersonationBanner;
